import { priceFromCost, clampParam } from "@acc/shared"
import { PriceType } from "../../../app/reducers/settingsReducer"

/**
 * Калькулятор цены WB с размерами (для товаров с объёмом — литраж), фронт.
 *
 * Делегирует математику движку priceFromCost из @acc/shared. LOGISTIC считается
 * из литража (pricePerLiter + extraPricePerLiter за каждый литр сверх первого).
 *
 * Конфиг комиссий: nalogInKassa=false, denominatorFees=[KOEF, NALOG], additives=[LOGISTIC].
 */
export const calcPriceWithSizes = (
  props: PriceType & {
    price?: number
    liters?: number
  },
): { price: number; old_price: number } => {
  const {
    liter_price,
    extra_liter_price,
    liters = 0,
    price = 0,
    sale = 0,
    margin = 0,
    profit = 0,
    ff = 0,
    coef = 0,
    tax = 0,
  } = props
  const pricePerLiter = liter_price || 0
  const extraPricePerLiter = extra_liter_price || 0
  const LOGISTIC = Math.max(
    pricePerLiter + (liters - 1) * extraPricePerLiter,
    0,
  )

  const currentPrice = priceFromCost(
    {
      price,
      margin: clampParam(margin, 0),
      minProfit: clampParam(profit, 0),
      ff: clampParam(ff, 0),
      nalog: clampParam(tax, 0),
      sale: Math.max(sale, 0) / 100,
      withSale: false,
    },
    {
      nalogInKassa: false,
      denominatorFees: [clampParam(coef, 0), clampParam(tax, 0)],
      additives: [LOGISTIC],
    },
  )
  const SALE = Math.max(sale, 0) / 100
  return {
    price: currentPrice,
    old_price: Math.ceil(currentPrice / (1 - SALE)),
  }
}
